import React, { useRef } from "react";
import MobileMenu from "../header/mobile-menu";
import { useUI } from "@/contexts/ui.context";
import useScrollLock from "@/utils/use-scroll-lock";
import { AnimatePresence, m } from "framer-motion";
import useOnClickOutside from "@/utils/use-click-outside";
export default function MenuDrawer() {
  const { isMenuOpen, setIsMenuOpen } = useUI();
  const ref = useRef(null);
  // useOnClickOutside(ref, () => setIsMenuOpen(!isMenuOpen));
  useScrollLock(isMenuOpen);

  return (
    <AnimatePresence mode="wait">
      {isMenuOpen && (
        <m.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: 100,
          }}
          exit={{ opacity: 0 }}
          className="fixed top-[78px] right-0 w-full h-[calc(100vh-78px)] flex items-start justify-end z-[1000]"
          key="overlay"
        >
          <m.div
            initial={{ x: "100%", opacity: 100 }}
            animate={{ x: 0, opacity: 100 }}
            exit={{ x: "100%", opacity: 100 }}
            transition={{ duration: 0.5 }}
            ref={ref}
            className="max-w-[500px] w-full h-full bg-beige"
            key="cart"
          >
            <MobileMenu />
          </m.div>
        </m.div>
      )}
    </AnimatePresence>
  );
}
